module.exports = __webpack_public_path__ + "img/sample_cabinet4.8ff9ef52.png";